<template>
	<el-menu
		class="el-menu-vertical"
		:collapse="isCollapse"
		@open="handleOpen"
		@close="handleClose"
		>
		<el-menu-item :style="toggleCss" @click="toggle">
			<el-icon>
				<arrow-left-bold v-if="!isCollapse"/>
				<icon-menu v-else/>
			</el-icon>
		</el-menu-item>
		<el-sub-menu index="1" v-if="isHost || isStore || isHostSub || isStoreSub || isMaster">
			<template #title>
				<el-icon>
					<user/>
				</el-icon>
				<span>매장관리</span>
			</template>
			<el-menu-item v-if="isMaster" index="1-1" @click="go({path: '/store/list'})">매장 관리</el-menu-item>
		</el-sub-menu>
		<el-sub-menu index="6" v-if="isMaster">
			<template #title>
				<el-icon>
					<service/>
				</el-icon>
				<span>고객센터</span>
			</template>
			<el-menu-item index="6-1" @click="go({path: '/cs/notice'})">공지사항</el-menu-item>
		</el-sub-menu>
		<el-sub-menu index="8" v-if="isHost || isStore || isMaster" >
			<template #title>
				<el-icon>
					<setting/>
				</el-icon>
				<span> 환경 설정</span>
			</template>
			<el-menu-item index="8-1" v-if="isMaster || isHost || isStore" @click="go({path: '/update/list'})">업데이트 관리</el-menu-item>
		</el-sub-menu>
	</el-menu>
</template>

<script src="./asideComp.js">
</script>

<style lang="scss" scoped>

html{
	font-size: 10px;
}
.el-menu-vertical {
	height: 100%;
	min-height: 40rem;
}

.el-menu-vertical:not(.el-menu--collapse) {
	width: 20rem;
	min-height: 40rem;
}
</style>
